'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useState } from 'react';

import type { Gallery } from '../../pages/gallery/page';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';

export function GalleryCard({ gallery }: { gallery: Gallery }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const allImages = [gallery.image, ...gallery.images];

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="relative col-span-1 aspect-square w-full">
        <Image
          onClick={handleOpenGallery(allImages, 0)}
          src={gallery.image.url}
          alt={resolveImageAlt(gallery?.image, gallery?.name)}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full cursor-pointer object-cover object-center"
          sizes="100vw"
        />
      </div>
    </>
  );
}
